/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicRouteCompletionStatsDto } from '../models/PublicRouteCompletionStatsDto';
import type { RouteFeatureDto } from '../models/RouteFeatureDto';
import type { RouteFilterRegionDto } from '../models/RouteFilterRegionDto';
import type { RouteMapItemDto } from '../models/RouteMapItemDto';
import type { RoutePopularityDto } from '../models/RoutePopularityDto';
import type { RoutePresetDto } from '../models/RoutePresetDto';
import type { RouteShareLinkDto } from '../models/RouteShareLinkDto';
import type { RouteSitemapEntryDto } from '../models/RouteSitemapEntryDto';
import type { RouteWeatherDto } from '../models/RouteWeatherDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoutesService {
  /**
   * List approved route presets with filters.
   * @param region
   * @param editorialRegionSlug Filter by editorial region slug (e.g. mazury, bieszczady).
   * @param query Full-text like filter for title, summary and public slugs.
   * @param maxDurationMin
   * @param difficulty
   * @param familyFriendly
   * @param sort
   * @param limit
   * @param mountainRegion Filter routes intersecting a named mountain region (e.g. Tatry, Bieszczady).
   * @param offset
   * @returns RoutePresetDto
   * @throws ApiError
   */
  public static routesControllerGetRoutePresets(
    region?: string,
    editorialRegionSlug?: string,
    query?: string,
    maxDurationMin?: number,
    difficulty?: 'easy' | 'moderate' | 'hard',
    familyFriendly?: boolean,
    sort?: 'popular' | 'recent',
    limit: number = 12,
    mountainRegion?: string,
    offset?: number,
  ): CancelablePromise<Array<RoutePresetDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/presets',
      query: {
        region: region,
        editorialRegionSlug: editorialRegionSlug,
        query: query,
        maxDurationMin: maxDurationMin,
        difficulty: difficulty,
        familyFriendly: familyFriendly,
        sort: sort,
        limit: limit,
        mountainRegion: mountainRegion,
        offset: offset,
      },
    });
  }
  /**
   * List approved routes for the public discovery map.
   * @param region
   * @param query
   * @param maxDurationMin
   * @param difficulty
   * @param familyFriendly
   * @returns RouteMapItemDto
   * @throws ApiError
   */
  public static routesControllerGetRouteMap(
    region?: string,
    query?: string,
    maxDurationMin?: number,
    difficulty?: 'easy' | 'moderate' | 'hard',
    familyFriendly?: boolean,
  ): CancelablePromise<Array<RouteMapItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/map',
      query: {
        region: region,
        query: query,
        maxDurationMin: maxDurationMin,
        difficulty: difficulty,
        familyFriendly: familyFriendly,
      },
    });
  }
  /**
   * List public filter regions for the route catalog.
   * @returns RouteFilterRegionDto
   * @throws ApiError
   */
  public static routesControllerGetRouteFilterRegions(): CancelablePromise<
    Array<RouteFilterRegionDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/regions',
    });
  }
  /**
   * Get popular routes by usage stats.
   * @param days
   * @param limit
   * @param region
   * @returns RoutePopularityDto
   * @throws ApiError
   */
  public static routesControllerGetPopularRoutes(
    days: number = 30,
    limit: number = 10,
    region?: string,
  ): CancelablePromise<Array<RoutePopularityDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/stats/popular',
      query: {
        days: days,
        limit: limit,
        region: region,
      },
    });
  }
  /**
   * List public route slugs for sitemap generation.
   * @returns RouteSitemapEntryDto
   * @throws ApiError
   */
  public static routesControllerGetRouteSitemap(): CancelablePromise<Array<RouteSitemapEntryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/sitemap',
    });
  }
  /**
   * Create signed public share link for route.
   * @param id
   * @returns RouteShareLinkDto
   * @throws ApiError
   */
  public static routesControllerCreateShareLink(id: string): CancelablePromise<RouteShareLinkDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/routes/{id}/share',
      path: {
        id: id,
      },
    });
  }
  /**
   * Resolve signed share token to route payload.
   * @param token
   * @returns RouteFeatureDto
   * @throws ApiError
   */
  public static routesControllerGetRouteByShareToken(
    token: string,
  ): CancelablePromise<RouteFeatureDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/shared/{token}',
      path: {
        token: token,
      },
      errors: {
        404: `Shared route not found or expired.`,
      },
    });
  }
  /**
   * Export route as GPX 1.1.
   * @param id
   * @returns string GPX payload.
   * @throws ApiError
   */
  public static routesControllerGetRouteGpx(id: string): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/{id}/gpx',
      path: {
        id: id,
      },
      errors: {
        404: `Route not found.`,
      },
    });
  }
  /**
   * Get current route payload by public slug.
   * @param slug
   * @returns RouteFeatureDto
   * @throws ApiError
   */
  public static routesControllerGetRouteBySlug(slug: string): CancelablePromise<RouteFeatureDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/slug/{slug}',
      path: {
        slug: slug,
      },
      errors: {
        404: `Route not found.`,
      },
    });
  }
  /**
   * Get 3-day weather forecast for a chosen point on the route.
   * @param id
   * @param point
   * @returns RouteWeatherDto
   * @throws ApiError
   */
  public static routesControllerGetRouteWeather(
    id: string,
    point?: 'start' | 'peak' | 'end',
  ): CancelablePromise<RouteWeatherDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/{id}/weather',
      path: {
        id: id,
      },
      query: {
        point: point,
      },
    });
  }
  /**
   * Get current route payload by route ID.
   * @param id
   * @param _public
   * @returns RouteFeatureDto
   * @throws ApiError
   */
  public static routesControllerGetRouteById(
    id: string,
    _public?: boolean,
  ): CancelablePromise<RouteFeatureDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/{id}',
      path: {
        id: id,
      },
      query: {
        public: _public,
      },
      errors: {
        404: `Route not found.`,
      },
    });
  }
  /**
   * Get the public number of users who completed the route.
   * @param routeId
   * @returns PublicRouteCompletionStatsDto
   * @throws ApiError
   */
  public static publicRouteCompletionStatsControllerGetPublicStats(
    routeId: string,
  ): CancelablePromise<PublicRouteCompletionStatsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/routes/{routeId}/completion-stats',
      path: {
        routeId: routeId,
      },
    });
  }
}
